// extracted by mini-css-extract-plugin
export default {"sider":"styles_sider__ofh9a","siteLogo":"styles_siteLogo__Xps5v"};